import classNames from "classnames";
import { t } from "i18next";
import React from "react";

import useCheckDevice from "@repo/shopifyV2/hooks/useCheckDevice";
import type { MailingAddress } from "@repo/shopifyV2/types/storefront.types";
import { formatOrderAddress } from "@repo/shopifyV2/utils/address";

import Button from "@atoms/Button";

import Address from "@molecules/Address";

import useLanguage from "@hooks/useLanguage";

import useCustomer from "@queries/useCustomer";

import { useLayoutStore } from "@store/layout";

interface IProps {
  address: MailingAddress;
  isDefaultAddress?: boolean;
  onCompletedMutation?: () => void | Promise<void>;
  openAddressForm?: (value: MailingAddress) => void;
  isShowButton?: boolean;
}

export default function AddressItem({ address, isDefaultAddress = false, onCompletedMutation, openAddressForm }: IProps) {
  const { isPC } = useCheckDevice();
  const { openModal } = useLayoutStore();
  const { lang } = useLanguage();

  const { deleteAddress, deleteAddressLoading } = useCustomer();

  const handleDeleteAddress = () => {
    openModal({
      title: "Delete Address",
      content: <p>{t("address_book.delete_address")}</p>,
      confirm: {
        label: "Delete",
        onClick: () => {
          void deleteAddress({ id: address.id }).then(() => {
            void onCompletedMutation?.();
            openModal(null);
          });
        },
      },
      cancel: {
        label: "Cancel",
        onClick: () => {
          openModal(null);
        },
      },
    });
  };

  // 배송지 정보
  const shippingAddress = formatOrderAddress({ address, lang });

  return (
    <>
      <div className={classNames("pc:col-span-3 col-span-8", !isPC && "flex justify-between")}>
        <Address {...shippingAddress} />
        {!isPC && isDefaultAddress ? <span>Default</span> : null}
      </div>
      <div className="pc:col-span-1 col-span-8 flex gap-2.5">
        <Button
          as="text"
          disabled={deleteAddressLoading}
          isActive={false}
          onClick={() => {
            window.scrollTo(0, 0);
            openAddressForm?.(address);
          }}
        >
          {t("edit")}
        </Button>
        <Button as="text" disabled={deleteAddressLoading} isActive={false} onClick={handleDeleteAddress}>
          {t("delete")}
        </Button>
      </div>
      {isPC && isDefaultAddress ? <span className="flex justify-end">Default</span> : null}
    </>
  );
}
